import { DatePicker, Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { HelpMessage } from 'utils/constants'
import CIMSTextArea from 'components/CIMSTextArea'
import { EJReportType, EJStatus } from '@cims-online/shared'
import { CommonEJFormItemsProps } from './types'
import { useEJReportsSelectOptionsContext } from '../../../../../EJReportsSelectOptionsContext'
import { useEffect, useState } from 'react'
import { DefaultOptionType } from 'antd/lib/select'
import { useWatch } from 'antd/lib/form/Form'
import { useDisabledOptions } from 'hooks/useDisabledOptions'

const Help = HelpMessage.EngineeringJudgements.EJLog

const CommonEJFormItems: React.VFC<CommonEJFormItemsProps> = ({
  statusId,
  editing,
  form,
  types,
  typeOptions,
}) => {
  const { optionsMap, selectProps } = useEJReportsSelectOptionsContext()
  const [closedDisabledOptions, { some: closedDisabled }] = useDisabledOptions({
    disabled: !!editing && statusId === EJStatus.Closed.id,
    reason: {
      why: 'invalid status',
      statusName: EJStatus.Closed.name,
    },
  })
  const [reportOptions, setReportOptions] = useState<
    DefaultOptionType[] | undefined
  >(undefined)
  const typeIdWatch = useWatch('typeId', form)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setReportOptions(
      optionsMap.get(
        EJReportType.fromId(
          types?.find(({ id }) => typeIdWatch === id)?.reportTypeId
        )?.classType
      )
    )
  }, [typeIdWatch, optionsMap, types])

  return (
    <>
      <CIMSFormItem
        name="typeId"
        label="Type"
        disabled={closedDisabledOptions}
        requiredMessage="Please select a Type"
        help={Help.Type}
      >
        <CIMSSelect
          simple
          options={typeOptions}
          disabled={closedDisabled}
          onChange={() =>
            form.setFieldsValue({
              reports: undefined,
              manualReportId: undefined,
            })
          }
        />
      </CIMSFormItem>
      {!!reportOptions ? (
        <CIMSFormItem
          label="Reports"
          name="reports"
          disabled={closedDisabledOptions}
          help={Help.Reports}
        >
          <CIMSSelect
            {...selectProps}
            options={reportOptions}
            disabled={closedDisabled}
          />
        </CIMSFormItem>
      ) : (
        <CIMSFormItem
          label="Reports"
          name="manualReportId"
          disabled={closedDisabledOptions}
          help={Help.Reports}
        >
          <Input disabled={closedDisabled} />
        </CIMSFormItem>
      )}
      <CIMSFormItem
        name="failureDate"
        label="Failure Date"
        requiredMessage="Please select a Failure Date"
        disabled={closedDisabledOptions}
        help={Help.FailureDate}
      >
        <DatePicker allowClear disabled={closedDisabled} />
      </CIMSFormItem>
      <CIMSFormItem
        name="failureDescription"
        label="Failure Description"
        disabled={closedDisabledOptions}
        help={Help.FailureDescription}
      >
        <CIMSTextArea disabled={closedDisabled} />
      </CIMSFormItem>
      <CIMSFormItem
        name="justification"
        label="Justification"
        disabled={closedDisabledOptions}
        help={Help.Justification}
      >
        <CIMSTextArea disabled={closedDisabled} />
      </CIMSFormItem>
      <CIMSFormItem
        name="notes"
        label="Notes"
        disabled={closedDisabledOptions}
        help={Help.Notes}
      >
        <CIMSTextArea disabled={closedDisabled} />
      </CIMSFormItem>
    </>
  )
}

export default CommonEJFormItems
